import React from 'react';

// Catches any render error so a single bug can't blank the whole app.
export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) { console.error('App crashed:', err, info); }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-gray-900 text-white">
          <div className="max-w-sm text-center">
            <h1 className="text-lg font-bold mb-2">Something went wrong</h1>
            <p className="text-sm text-gray-300 mb-4">{String((this.state.err && this.state.err.message) || this.state.err)}</p>
            <button onClick={() => location.reload()} className="bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-lg font-semibold">Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
